export class bigData {
    public bigData = {
        userId: '',
        userName: '',
        softwareId: '123',
        url: 'https://bigdata.veryengine.cn/',
        webUrl: 'wss://bigdata.veryengine.cn/',
        ws: undefined,
        create: function (info) {
            let tmp = [];
            for (let key in info) {
                tmp.push({ softwareId: this.softwareId, key: key, strValue: info[key] });
            }
            return axios.post(this.url + "Element/BatchUniqueAdd", JSON.stringify(tmp), { headers: { 'Content-Type': 'application/json;charset=UTF-8' } });
        },
        operation: function (op) {
            let tmp = [];
            for (let key in op) {
                tmp.push({ softwareId: this.softwareId, userId: this.userId, key: '操作深度', strValue: key, numValue: op[key] })
            }
            return axios.post(this.url + "Element/BatchAdd", JSON.stringify(tmp), { headers: { 'Content-Type': 'application/json;charset=UTF-8' } });
        },
        singleScore: function (ss) {
            let tmp = [];
            for (let key in ss) {
                tmp.push({ softwareId: this.softwareId, userId: this.userId, key: 'singleScore', strValue: key, numValue: ss[key] })
            }
            return axios.post(this.url + "Element/BatchAdd", JSON.stringify(tmp), { headers: { 'Content-Type': 'application/json;charset=UTF-8' } });
        },

        score: function (s) {
            let tmp = [];
            for (let key in s) {
                tmp.push({ softwareId: this.softwareId, userId: this.userId, key: 'score', strValue: key, numValue: s[key] })
            }
            return axios.post(this.url + "Element/BatchUniqueUserAdd", JSON.stringify(tmp), { headers: { 'Content-Type': 'application/json;charset=UTF-8' } });
        },
        stopTime: function (time) {
            let tmp = { softwareId: this.softwareId, userId: this.userId, key: 'stopTime', strValue: time.key, numValue: time.value };
            return axios.post(this.url + "Element/Add", JSON.stringify(tmp), { headers: { 'Content-Type': 'application/json;charset=UTF-8' } });
        },
        origin: function (from) {
            let tmp = { softwareId: this.softwareId, userId: this.userId, key: 'origin', strValue: from };
            return axios.post(this.url + "Element/AddNum", JSON.stringify(tmp), { headers: { 'Content-Type': 'application/json;charset=UTF-8' } })
        },
        jsonpcallback: function (rs) {
            var province = rs['content']['address_detail']['province'];
            province = province.substring(0, province.length - 1);
            let tmp = { softwareId: this.softwareId, userId: this.userId, key: 'map', strValue: province };
            axios.post(this.url + "Element/AddNum", JSON.stringify(tmp), { headers: { 'Content-Type': 'application/json;charset=UTF-8' } })
        },
        connectWeb:function(softwareId,userId,userName){
            let that=this;
            if(softwareId != null&&userId!=null&&userName!=null){
                this.userId=userId;
                this.softwareId=softwareId;
                this.userName=userName;
                if('WebSocket' in window){
                    this.ws = new WebSocket(this.webUrl+"Client/"+softwareId+"/"+userId);
                }else if('MozWebSocket' in window){
                    this.ws = new window["MozWebSocket"](this.webUrl+"Client/"+softwareId+"/"+userId);
                }else{
                    alert("该浏览器不支持websocket");
                }
                this.ws.onmessage = function(evt){
                    console.log(evt.data);
                }
                this.ws.onclose = function(evt){
                    console.error("连接中断");
                }
                this.ws.onopen = function(evt){
                    console.log("连接成功");
                    this.send("userName:"+userName);
                    let geolocation = new BMap.Geolocation()
                    geolocation.getCurrentPosition(function (r) {
                    if(this.getStatus() == 0){
                        var province = r['address']['province'];
                        province=province.substring(0,province.length-1);
                        let tmp={softwareId:that.softwareId,userId:that.userId,key:'map',strValue:province};
                        axios.post(that.url+"Element/AddNum",JSON.stringify(tmp),{headers: { 'Content-Type': 'application/json;charset=UTF-8'}})
                    }
                })
                }.bind(this.ws)
            }else {
                alert("软件id为空");
            }
        },
        sendInfo: function (info) {
            this.ws.send('info:' + info);
        }
    }
}

